module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "yu-btn",
    class: [
      _vm.type ? 'yu-btn--' + _vm.type : '',
      _vm.size ? 'yu-btn--' + _vm.size : '',
      {
        'is-disabled': _vm.disabled,
        'is-loading': _vm.loading,
        'is-plain': _vm.plain
      }
    ],
    attrs: {
      "disabled": _vm.disabled,
      "data-com": "YuButton",
      "type": _vm.nativeType
    },
    on: {
      "&click": function($event) {
        _vm.fnClick($event)
      }
    }
  }, [(_vm.$slots.icon) ? _c('span', {
    staticClass: "yu-btn-icon"
  }, [_vm._t("icon")], 2) : _vm._e(), _c('span', {
    staticClass: "yu-btn-cont"
  }, [(_vm.$slots.default) ? _vm._t("default") : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-083cc598","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/YouUI/Button/Button.vue
// module id = 280
// module chunks = 0